import { BlogSection } from '@/types/blog';

export const unterschiedeTabelle: BlogSection = {
  id: 'unterschiede-tabelle',
  title: 'Marktteilnehmer im Überblick',
  content: `
    <div class="my-8 overflow-x-auto rounded-lg border border-muted shadow-sm">
      <table class="w-full caption-bottom text-sm">
        <thead>
          <tr class="border-b border-muted bg-muted/30">
            <th class="h-12 px-4 text-left align-middle font-semibold">Typ</th>
            <th class="h-12 px-4 text-left align-middle font-semibold">Rechtsgrundlage</th>
            <th class="h-12 px-4 text-left align-middle font-semibold">Interessenlager</th>
            <th class="h-12 px-4 text-left align-middle font-semibold">Vergütung</th>
            <th class="h-12 px-4 text-left align-middle font-semibold">Unabhängigkeit</th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-b border-muted/50">
            <td class="p-4 align-middle font-medium">Gebundener Vermittler</td>
            <td class="p-4 align-middle">§ 34d Abs. 7 GewO</td>
            <td class="p-4 align-middle">Versicherer</td>
            <td class="p-4 align-middle">Provision</td>
            <td class="p-4 align-middle">Niedrig</td>
          </tr>
          <tr class="border-b border-muted/50">
            <td class="p-4 align-middle font-medium">Mehrfachagent</td>
            <td class="p-4 align-middle">§ 34d Abs. 1 GewO</td>
            <td class="p-4 align-middle">Versicherer</td>
            <td class="p-4 align-middle">Provision</td>
            <td class="p-4 align-middle">Mittel</td>
          </tr>
          <tr class="border-b border-muted/50">
            <td class="p-4 align-middle font-medium">Versicherungsmakler</td>
            <td class="p-4 align-middle">§ 34d Abs. 1 GewO</td>
            <td class="p-4 align-middle">Kunde</td>
            <td class="p-4 align-middle">Courtage</td>
            <td class="p-4 align-middle">Hoch</td>
          </tr>
          <tr class="border-b border-muted/50">
            <td class="p-4 align-middle font-medium">Honorarberater</td>
            <td class="p-4 align-middle">§ 34h GewO</td>
            <td class="p-4 align-middle">Kunde</td>
            <td class="p-4 align-middle">Honorar</td>
            <td class="p-4 align-middle">Maximal</td>
          </tr>
          <tr>
            <td class="p-4 align-middle font-medium">Finanzcoach</td>
            <td class="p-4 align-middle">Prozessbegleitung</td>
            <td class="p-4 align-middle">Kunde (neutral)</td>
            <td class="p-4 align-middle">Honorar</td>
            <td class="p-4 align-middle">Maximal</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="text-sm text-muted-foreground italic">
      *Versicherungsberater nach §34d Abs. 2 GewO beraten ebenfalls auf Honorarbasis ohne Vermittlung.
    </p>
  `
};
